import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './superuser-selector-modal.css'

const SuperuserSelectorModalPortalUsers = ({ handleSearchInputChange, results }) => (
  <div styleName="content">
    <div styleName="search">
      Search by Portal User ID, name or email:
      <input styleName="input" type="text" onChange={handleSearchInputChange} />
    </div>
    {results && (
      <div styleName="results">
        Click to sudo user:
        <ul>
          {results && results.map((item, index) => (
            <li key={index}>
              <a href={`/superuser_choose_user?user_id=${item.id}`} styleName="link">
                {item.firstName} {item.lastName} ({item.id}) - {item.email}
              </a>
            </li>
          ))}
        </ul>
      </div>
    )}
  </div>
)

SuperuserSelectorModalPortalUsers.propTypes = {
  handleSearchInputChange: PropTypes.func,
  results: PropTypes.array,
}

export default CSSModules(SuperuserSelectorModalPortalUsers, styles)



/** WEBPACK FOOTER **
 ** ./src/components/superuser-selector-modal/superuser-selector-modal-portal-users.js
 **/